import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { SearchButtonStyled } from '../../SearchButton';
import { ABUtils, LocationUtils } from '../../../utils';
import { SlideGroupContextProvider } from '../../../components/SlideManager';
import { DateFieldRoundTrip } from '../../FlightsManager/MobileFields/DateFieldRoundTrip';
import { HotelStandaloneRoomSelectorMobile } from '../../RoomSelector/HotelStandalonePaxSelector';
import { SegmentContext } from '../../FlightsManager/Segment/SegmentManager/Context';
import { ConnectedArrivalField } from '../../FlightsManager/MobileFields';
import { getSegments } from '../../../redux/currentSearch/selectors';
import { EntryPoint, SearchSegment } from '../../../models';
import {
    HSA_SEARCH_CLICK,
    HSA_SEARCH_FORM,
    withTrackComponentDisplayed,
} from '../../../utils/HtmlEvents';
import {
    ClickTrackArrival,
    ClickTrackDates,
    ClickTrackRooms,
} from '../SearchFormFieldsClickableWrapper';
import { DatesErrorMessage, DestinationErrorMessage } from './ErrorMessage';

const HotelManagerMobile = ({ segments }) => {
    const { isHotelsVisibility } = ABUtils.getABs();
    const { t } = useTranslation();
    const [firstSegment] = segments;
    const isFirstInteraction = useRef(true);

    const handleSearchFormClick = () => {
        if (isFirstInteraction.current && window?.google) {
            window?.google?.accounts?.id?.cancel();
            isFirstInteraction.current = false;
        }
    };

    const getLocationText = (location, direction) => {
        return LocationUtils.getFieldText(location, direction, EntryPoint.HOTELS);
    };

    const wrapperClassNames = classNames({
        'odf-space-inner-top-m odf-space-inner-right-m odf-space-inner-left-m odf-bg-base': true,
        'od-flights-manager-wrapper': isHotelsVisibility,
    });
    return (
        <div className={wrapperClassNames}>
            <div onClick={handleSearchFormClick}>
                <SegmentContext.Provider value={{ segment: firstSegment }}>
                    <SlideGroupContextProvider>
                        <ClickTrackArrival>
                            <ConnectedArrivalField
                                getLocationText={getLocationText}
                                icon={'location'}
                                ErrorMessageComponent={DestinationErrorMessage}
                            />
                        </ClickTrackArrival>
                        <ClickTrackDates>
                            <DateFieldRoundTrip ErrorMessageComponent={DatesErrorMessage} />
                        </ClickTrackDates>
                        <ClickTrackRooms>
                            <HotelStandaloneRoomSelectorMobile />
                        </ClickTrackRooms>
                    </SlideGroupContextProvider>
                </SegmentContext.Provider>
            </div>
            <div className="odf-space-outer-top-m odf-space-outer-bottom-l">
                <div id="home_login_toggle" className="shell-integration_portal" />
            </div>
            <div className="odf-space-outer-top-m">
                <SearchButtonStyled
                    astId={window?.crypto?.randomUUID()}
                    block
                    hotelStandalone
                    testId="search-hotel-standalone-btn"
                    htmlEventID={HSA_SEARCH_CLICK}
                >
                    {t('flightsManager.search.reduced')}
                </SearchButtonStyled>
            </div>
        </div>
    );
};

HotelManagerMobile.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment).isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
});

export const HotelManagerMobileWithHotelStandalone = connect(mapStateToPropsSelector)(
    withTrackComponentDisplayed(HotelManagerMobile, HSA_SEARCH_FORM),
);
